<template>
  <div class="entry">
    <Header @clickBack="clickBack" />
    <div class="container">
      <EntryButtons
        @clickPhoneSignUp="$emit('clickPhoneSignUp', 'agree')"
        @kakaoSignUp="kakaoSignUp"
        @kakaoSignIn="kakaoSignIn"
      />
    </div>
  </div>
</template>

<script>
import Header from "./entry/Header.vue";
import EntryButtons from "./entry/EntryButtons.vue";
export default {
  components: { Header, EntryButtons },
  methods: {
    kakaoSignUp(kakaoAccount) {
      this.$emit("kakaoSignUp", kakaoAccount);
    },
    kakaoSignIn(e) {
      this.$emit("kakaoSignIn", e);
    },
    clickBack() {
      this.$router.push({ path: "/login" }).catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.entry {
  .btnBox {
    // margin: 35px 25px 25px 25px;
  }

  .entry-header {
    position: relative;
    padding: 1.5rem 1rem 2.5rem;
    margin-bottom: calc(45vh - 228px);
    text-align: center;
    background-image: url(~@/assets/images/common/login_header_bg.jpeg);
    background-size: cover;
    background-color: #ffffff;
    color: #ffffff;
    border-radius: 0 0 30px 30px;
    // min-height: 400px;
    height: 300px;
    overflow: hidden;

    .gradation {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(#00420a, rgba(0, 0, 0, 0.5));
      opacity: 0.8;
    }

    .header-top {
      position: relative;
      text-align: left;
      padding: 10px 0;
      // > div {
      //   width: 50%;
      //   display: inline-block;
      //   vertical-align: middle;
      // }
      // .top-logo {
      //   width: 40px;
      // }

      .v-btn {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
      }
    }

    .page-title {
      position: relative;

      h1 {
        color: #ffffff;
        font-weight: 600;
      }

      img {
        width: 176px;
      }
    }

    .header-bottom {
      position: absolute;
      left: 0;
      bottom: 30px;
      width: 100%;
      text-align: center;
      padding: 10px 0;

      > div {
        display: inline-block;
        vertical-align: middle;
      }

      .logo {
        height: 30px;
      }

      .title {
        margin-top: 5px;
        height: 20px;
      }

      .v-btn {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
      }
    }
  }

  .buttons {
    margin: 0 auto;
    width: 90vw;
    padding-bottom: 0;
  }

  @media (min-width: 768px) {
    div.buttons {
      width: 100%;
    }
  }

  .v-btn.btn-kakao {
    background: #f6d523;
    color: #000000;
  }

  .link-group {
    margin: 2rem 0;
    text-align: right;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .v-label {
      font-size: 16px;
      margin-left: 10px;
      color: #000000;
      font-weight: 500;
    }

    .v-btn {
      font-weight: 700;
      background-color: $mid-green;
      color: #ffffff;
      font-size: 14px;
      height: 28px;
    }
  }
}

@media (max-width: 768px) {
  div.entry {
  }
}
</style>